const question = {
    yesFond: { point: [1] },
    yesMixte: { point: [2] },
    yesCompte: { point: [3] },
    no: { point: [0] },
};

export default question;
